// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SigningRecord } from './signing-record';
import {
    SigningRecordFromJSON,
    SigningRecordFromJSONTyped,
    SigningRecordToJSON,
    SigningRecordToJSONTyped,
} from './signing-record';

/**
 * 
 * @export
 * @interface SigningRecordsResponse
 */
export interface SigningRecordsResponse {
    /**
     * 
     * @type {string}
     * @memberof SigningRecordsResponse
     */
    dta_id: string;
    /**
     * 
     * @type {Array<SigningRecord>}
     * @memberof SigningRecordsResponse
     */
    signing_records: Array<SigningRecord>;
    /**
     * 
     * @type {number}
     * @memberof SigningRecordsResponse
     */
    total: number;
}

/**
 * Check if a given object implements the SigningRecordsResponse interface.
 */
export function instanceOfSigningRecordsResponse(value: object): value is SigningRecordsResponse {
    if (!('dta_id' in value) || value['dta_id'] === undefined) return false;
    if (!('signing_records' in value) || value['signing_records'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function SigningRecordsResponseFromJSON(json: any): SigningRecordsResponse {
    return SigningRecordsResponseFromJSONTyped(json, false);
}

export function SigningRecordsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SigningRecordsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'dta_id': json['dta_id'],
        'signing_records': ((json['signing_records'] as Array<any>).map(SigningRecordFromJSON)),
        'total': json['total'],
    };
}

export function SigningRecordsResponseToJSON(json: any): SigningRecordsResponse {
    return SigningRecordsResponseToJSONTyped(json, false);
}

export function SigningRecordsResponseToJSONTyped(value?: SigningRecordsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dta_id': value['dta_id'],
        'signing_records': ((value['signing_records'] as Array<any>).map(SigningRecordToJSON)),
        'total': value['total'],
    };
}
